/* eslint-disable  */
import React from "react";

/**
 * Placeholder shaped like <ProductCard />, for the products grid.
 * The generic <Loader /> renders a stat-cards + table skeleton, which is the
 * wrong shape for this page and pushed the real content down the page while it
 * loaded. Uses the shared `gskel` shimmer primitive from index.css.
 */
function ProductCardSkeleton() {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm overflow-hidden border border-gray-100 dark:border-gray-700">
      {/* Image — `.gskel` is declared after the Tailwind layers in index.css, so
          its 8px radius wins over a `rounded-*` utility; set it inline instead. */}
      <div className="h-36 bg-gray-50 dark:bg-gray-700">
        <span className="gskel w-full h-full" style={{ borderRadius: 0 }} />
      </div>

      {/* Body */}
      <div className="p-3">
        <span className="gskel h-3.5 w-11/12 mb-1.5" />
        <span className="gskel h-3.5 w-2/3 mb-3" />

        {/* Price */}
        <div className="flex items-center gap-2 mb-3">
          <span className="gskel h-4 w-20" />
          <span className="gskel h-3 w-12" />
        </div>

        {/* Actions */}
        <div className="flex items-center gap-1.5">
          <span className="gskel h-8 flex-1" />
          <span className="gskel h-8 w-8" />
          <span className="gskel h-8 w-8" />
        </div>
      </div>
    </div>
  );
}

export function ProductGridSkeleton({ count = 10 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <ProductCardSkeleton key={index} />
      ))}
    </>
  );
}

export default ProductCardSkeleton;
